<template>
  <div v-on-click-outside="closeMenu" class="relative z-10 rounded-sm bg-white">
    <icon-button
      role="download-menu-button"
      view-box="0 -5 17 24"
      :icon="IconDownload"
      @click.stop="toggleMenu"
    />
    <div
      v-show="showMenu"
      class="absolute right-0 z-10 mt-1 max-h-60 overflow-y-auto rounded-md bg-gray-100 text-sm text-gray-500 shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm"
    >
      <div v-if="fileTypes.length > 1" class="flex px-5 py-5">
        <lf-button
          v-for="(fileType, i) in fileTypes"
          :key="i"
          class="h-9 w-32 px-3 text-gray-500 uppercase focus:outline-hidden"
          :class="{
            'bg-primary sm:text-white': selectedFileType === fileType,
            'bg-white': selectedFileType !== fileType,
            'ml-5': i > 0,
          }"
          @click="selectFileType(fileType)"
        >
          {{ fileType }}
        </lf-button>
      </div>
      <div class="w-full bg-white py-5">
        <primary-button
          class="mx-auto h-10 w-10/12 bg-primary focus:outline-hidden"
          @click.stop="emitDownload"
        >
          {{ $t("COMMON.DOWNLOAD") }}
          <span v-if="fileTypes.length === 1" class="uppercase">
            &nbsp;{{ selectedFileType }}
          </span>
        </primary-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

import IconDownload from "@/components/icons/IconDownload.vue";
import IconButton from "@/components/ui/buttons/IconButton.vue";

const props = defineProps({
  fileTypes: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(["download"]);

const showMenu = ref(false);
const selectedFileType = ref(props.fileTypes[0]);

const selectFileType = (format) => {
  selectedFileType.value = format;
};

const toggleMenu = () => {
  if (!showMenu.value) {
    document.body.click();
  }
  showMenu.value = !showMenu.value;
};

const closeMenu = () => {
  showMenu.value = false;
};

const emitDownload = () => {
  closeMenu();
  emit("download", selectedFileType.value);
};
</script>
